import ApiHttp from "./ApiHttp";
import { MODEL_STR_NAMES } from "./types/models/v1";

export default class Organization {
  constructor(props) {
    this.uuid = props.uuid;
    this.name_legal = props.name_legal;
    this.name_dba = props.name_dba;
    this.ach_dual_approval_required = props.ach_dual_approval_required;
    this.dual_approval_required = props.dual_approval_required;
    this.dual_approval_user_control = props.dual_approval_user_control;
    this.international_wire_dual_approval_required =
      props.international_wire_dual_approval_required;
    this.address = props.address;
    this.ach_dual_approval_expiration_grace_period_days =
      props.ach_dual_approval_expiration_grace_period_days;
    this.affiliated_organizations = props.affiliated_organizations;
  }

  static dualApprovalRequired(orgUuid, method = "GET", value = undefined) {
    return ApiHttp.fetch(
      `organizations/${orgUuid}/dual_approval_required`,
      {
        method,
      },
      {
        value,
      },
    ).then((res) => {
      return Organization.deserialize(res.organization);
    });
  }

  static async getOrganization(orgUuid, method = "GET") {
    const response = await ApiHttp.fetch(`organizations/${orgUuid}/`, {
      method,
    });
    return Organization.deserialize(response);
  }

  static async setOrganization(orgUuid, method = "PATCH", value) {
    const response = await ApiHttp.fetch(
      `organizations/${orgUuid}/`,
      {
        method,
      },
      value,
    );
    return Organization.deserialize(response);
  }

  static getNumberOfDualApprovalRequests() {
    return ApiHttp.fetch(`approval_requests`, {
      method: "GET",
      params: { exclude_user_requests: true },
    }).then((res) => res.meta.total);
  }

  static getOrganizationHasMultipleApprovalUsers(organizationUsers) {
    if (!organizationUsers) {
      return false;
    }
    const hasApprovalPermission = (organizationUser) =>
      organizationUser.role.permissions.some(
        (p) =>
          ["*", MODEL_STR_NAMES.DUAL_APPROVAL_REQUEST].includes(p.model_str) &&
          ["*", "write"].includes(p.operation),
      );
    return organizationUsers.filter(hasApprovalPermission).length > 1;
  }

  async updateBusinessAddress(address, deviceId, deviceRequestId) {
    const response = await ApiHttp.fetch(
      `organizations/${this.uuid}/address`,
      { method: "PUT" },
      { device_id: deviceId, device_request_id: deviceRequestId, ...address },
    );
    return response;
  }

  /*
   *  Factory method returning a new instance of Organization from
   *  an ApiHttp serialized Organization
   */
  static deserialize(payload) {
    return new Organization({
      uuid: payload.uuid,
      name_legal: payload.name_legal,
      name_dba: payload.name_dba,
      ach_dual_approval_required: payload.ach_dual_approval_required,
      dual_approval_required: payload.dual_approval_required,
      dual_approval_user_control: payload.dual_approval_user_control,
      international_wire_dual_approval_required:
        payload.international_wire_dual_approval_required,
      address: payload.address,
      ach_dual_approval_expiration_grace_period_days:
        payload.ach_dual_approval_expiration_grace_period_days,
      affiliated_organizations: payload.affiliated_organizations,
    });
  }

  serialize() {
    return {
      uuid: this.uuid,
      ach_dual_approval_required: this.ach_dual_approval_required,
      dual_approval_required: this.dual_approval_required,
      dual_approval_user_control: this.dual_approval_user_control,
      international_wire_dual_approval_required:
        this.international_wire_dual_approval_required,
      address: this.address,
      ach_dual_approval_expiration_grace_period_days:
        this.ach_dual_approval_expiration_grace_period_days,
      affiliated_organizations: this.affiliated_organizations,
    };
  }
}
